<!--suppress ALL -->
<template>
  <detail-template-v2 @back="backListPage">
    <template #header>
      <!--      <el-page-header-->
      <!--        :title="''"-->
      <!--        class="has-border__bottom"-->
      <!--        @back="backListPage"-->
      <!--      >-->
      <!--        <template #content>-->
      <div class="docTags" style="margin-bottom: 15px">
        <el-tag size="mini" class="priority lv2" v-if="isAutoBcc">
          <i class="fas fa-exclamation-triangle"></i>
          {{ isAutoBccDuThao ? "BCC-DT" : "BCC" }}
        </el-tag>
        <el-tag size="mini" class="priority lv3" v-if="incomingDoc.docTypeName"
          >{{ incomingDoc.docTypeName }}
        </el-tag>
        <el-tag
          v-if="isShowPiority(incomingDoc.priorityId)"
          size="mini"
          :class="['priority', getPiorityClass(incomingDoc.priorityId)]"
        >
          <i class="fas fa-bolt"></i>
          {{ incomingDoc.priorityName }}
        </el-tag>
        <vb-process-type-tag
          v-if="userVbIncomingProcess"
          :processType="userVbIncomingProcess.processType"
          class="margin-right-10"
        >
        </vb-process-type-tag>
        <div
          :style="
            !vbAttachment
              ? 'width: 80%; margin-bottom: 15px; height: 60px;'
              : 'width: 80%; margin-bottom: 15px;'
          "
          v-if="isUpdateFile"
        >
          <el-form ref="form" :model="form" inline-message>
            <div class="file-uploaded input-none__border" v-if="vbAttachment">
              <div class="file-uploaded">
                <div class="file clickable flex-row flex__between">
                  <a
                    v-openInNewTab
                    :href="
                      getToken(vbAttachment.id)
                        | buildAttachmentURL({
                          type: DOWNLOAD_OPTION.TYPE.ORIGINAL,
                        })
                    "
                    class="flex-row flex__left"
                  >
                    <fileTypeImage
                      :fileExtention="vbAttachment.fileExtention"
                      :customClass="'icon-small margin-right-10'"
                    />
                    <span class="fileName font-weight_normal">{{
                      vbAttachment.fileName
                    }}</span>
                  </a>
                  <i
                    class="
                      el-icon-circle-close
                      margin-left-10
                      font-size__large
                      color__red
                    "
                    @click="removeUploadAttachment"
                  ></i>
                </div>
              </div>
            </div>
            <el-form-item prop="attachment" class="input-no__label" v-else>
              <el-upload
                class="
                  upload-demo
                  style-fullWidth
                  input-border__bottom input-border__radius__0
                "
                drag
                :action="uploadAttachmentURL"
                size="mini"
                :on-success="
                  (response) =>
                    onUploadSuccess(response).then((response) =>
                      uploadAttachmentSuccess(response)
                    )
                "
                :data="uploadAttachmentAdditionalData"
                :file-list="form.attachmentFiles"
                :show-file-list="false"
                :headers="uploadAttachmentHeaders"
                :accept="DOCUMENT_FILE.ACCEPT_TYPES_DOC_OUT"
                :before-upload="
                  (file) =>
                    validateUploadFile(
                      file,
                      {
                        acceptFileTypes: DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT,
                      },
                      buildMessageUploadOnlyPdf()
                    )
                "
                :on-error="onUploadError"
                :on-change="() => (isUploadingDocFlag = true)"
                v-loading="isUploadingDocFlag && isUploading"
              >
                <div class="el-upload__text">
                  <p class="margin-0 padding-0">
                    Tải file đính kèm
                    <span class="font-italic font-size__small color__red"
                      >* (Định dạng file pdf)</span
                    >
                  </p>
                  <i
                    class="fas fa-cloud-upload color__blue font-size__large"
                  ></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <!-- v-if="vbAttachment && vbAttachment.id" -->
        <a
          v-else
          v-openInNewTab
          :href="
            getToken(vbAttachment.id)
              | buildAttachmentURL({
                type: userVbIncomingProcessId
                  ? DOWNLOAD_OPTION.TYPE.PDF
                  : DOWNLOAD_OPTION.TYPE.ORIGINAL,
              })
          "
        >
          <el-tooltip
            content="Xem nội dung văn bản"
            placement="top"
            :open-delay="300"
          >
            <i
              class="fas fa-cloud-download fa-cloud-download-docin color__blue"
            ></i>
          </el-tooltip>
        </a>
      </div>
      <h4 class="title-name style-fullWidth">{{ incomingDoc.quote }}</h4>
      <!--        </template>-->
      <!--      </el-page-header>-->
    </template>

    <template #main>
      <div class="group__info margin-top-10 padding-bottom-10">
        <div class="title font-size__medium">Thông tin</div>
        <div class="ctn">
          <div class="list-info width__100">
            <div
              class="item flex-row flex__left margin-bottom-10"
              v-if="vbDocInBook"
            >
              <div class="label font-size__small txt-right">Số đến:</div>
              <div class="content width__100 has-border__bottom">
                {{ (vbDocInBook ? vbDocInBook.bookNumber : null) || "-" }}
              </div>
            </div>
            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">Ngày đến:</div>
              <div class="content width__100 has-border__bottom">
                {{
                  incomingDoc.incomingDate
                    | dateFormatter({
                      nullValue: "-",
                      dateFormat: "DD/MM/YYYY",
                    })
                }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">Số ký hiệu:</div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.docCode || "-" }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">Ngày văn bản:</div>
              <div class="content width__100 has-border__bottom">
                {{
                  incomingDoc.docDate
                    | dateFormatter({
                      nullValue: "-",
                      dateFormat: "DD/MM/YYYY",
                    })
                }}
              </div>
            </div>

            <div
              class="item flex-row flex__left margin-bottom-10"
              v-if="incomingDoc.forwardDeptName"
            >
              <div class="label font-size__small txt-right">
                Đơn vị chuyển tiếp :
              </div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.forwardDeptName }}
              </div>
            </div>
            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">
                Đơn vị phát hành (bên trong):
              </div>
              <div class="content width__100 has-border__bottom">
                {{ labelDepartmentPublic() || "-" }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">
                Đơn vị phát hành (bên ngoài):
              </div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.outsidePublisherName || "-" }}
              </div>
            </div>

            <!--người ký duyệt-->
            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">
                Người ký duyệt:
              </div>
              <div class="content width__100 has-border__bottom">
                {{ signerName || "-" }}
              </div>
            </div>

            <div
              class="item flex-row flex__left margin-bottom-10"
              v-if="incomingDoc.forwardDeptName"
            >
              <div class="label font-size__small txt-right">Nơi gửi:</div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.forwardDeptName || "-" }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">Hạn xử lý:</div>
              <div class="content width__100 has-border__bottom">
                {{
                  incomingDoc.deadlineDate
                    | dateFormatter({
                      nullValue: "-",
                      dateFormat: "DD/MM/YYYY HH:mm",
                    })
                }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">
                Số trang/Số bản:
              </div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.numberOfPage || "-" }} /
                {{ incomingDoc.numberOfCopy || "-" }}
              </div>
            </div>

            <div class="item flex-row flex__left margin-bottom-10">
              <div class="label font-size__small txt-right">Ghi chú:</div>
              <div class="content width__100 has-border__bottom">
                {{ incomingDoc.description || "-" }}
              </div>
            </div>

            <div
              class="item flex-row flex__left margin-bottom-10"
              v-if="isBanHanhTrucLienThong"
            >
              <div class="label font-size__small txt-right">
                Văn bản quy phạm pháp luật
              </div>
              <div class="content width__100 has-border__bottom">
                <el-checkbox
                  :border="false"
                  v-model="isLawDocument"
                  class="style-fullWidth"
                  :disabled="true"
                ></el-checkbox>
              </div>
            </div>

            <div
              class="item flex-row flex__left margin-bottom-10"
              v-if="isBanHanhTrucLienThong"
            >
              <div class="label font-size__small txt-right">Loại chỉ đạo</div>
              <div class="content width__100 has-border__bottom">
                {{ steeringTypeLabel || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="docRelations && docRelations.length > 0"
        class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"
      >
        <div class="title font-size__medium">Văn bản liên quan</div>
        <div class="ctn">
          <template>
            <el-table
              class="table detailRelatedDocs"
              :data="docRelations"
              style="max-width: 100%; width: 100%"
              size="mini"
            >
              <el-table-column label="Trích yếu" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="docName flex-row flex__left margin-right-10">
                    <file-type-image
                      :custom-class="''"
                      :file-extention="scope.row.fileExtention"
                    >
                    </file-type-image>
                    <a
                      class="txt style-fullWidth margin-left-10 color__black"
                      :href="
                        getTokenDocRelation(scope.row.id)
                          | buildAttachmentURL({
                            type:
                              scope.row.objectTypeRelateTo ==
                              DOC_RELATION_OBJECT_TYPE.ATTACHMENT
                                ? DOWNLOAD_OPTION.TYPE.ORIGINAL
                                : DOWNLOAD_OPTION.TYPE.PDF,
                          })
                      "
                      v-openInNewTab
                    >
                      {{ scope.row.quote || "-" }}
                    </a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Loại văn bản"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ getRelationTypeLabel(scope.row.relationType) || "-" }}
                </template>
              </el-table-column>

              <el-table-column
                label="Số ký hiệu"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.docCode || "-" }}
                </template>
              </el-table-column>
              <el-table-column
                label="Ngày văn bản"
                width="135"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{
                    scope.row.docDate
                      | dateFormatter({
                        dateFormat: "DD/MM/YYYY",
                        nullValue: "-",
                      })
                  }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <!-- <doc-relations-detail
        :title="'Văn bản scan'"
        :docId="id"
        ref="docRelationsForm"
      ></doc-relations-detail> -->
      <!-- hiển thị luồng xử lý -->
      <vbden-luongxuly
        :docId="id"
        @docFlowChange="docFlowChange"
        v-if="!vbDocBccInfo"
      />
      <vbdi-luongxuly-wrapper
        v-else
        :id="vbDocBccInfo.vbOutgoingDocId"
      ></vbdi-luongxuly-wrapper>
      <!-- hiển thị luồng xử lý:end -->
    </template>

    <template #footer>
      <div
        class="footer"
        v-if="
          !isAutoBccDuThao &&
          (!isAutoBcc || userVbIncomingProcessId) &&
          checkCurrentActive()
        "
      >
        <div class="flex-row flex__left form-button__action">
          <el-button
            class="detailBtn detailBtnPrimary"
            @click="openCxlDialog"
            v-if="
              (isEnableChuyenXuLiCaNhan() || isEnableChuyenXuLiDonVi()) &&
              !isViewAsUyQuyen
            "
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            &nbsp;Chuyển xử lý
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="isOpenChoYKienDialog = true"
            v-if="
              isPhieuYKien &&
              deptCode === HDTV_DEPT_CODE &&
              !isViewAsUyQuyen &&
              isExistOpnionForm
            "
          >
            <i class="fas fa-check-circle font-size__small"></i>
            &nbsp;Cho ý kiến
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="isOpenKetThucDialog = true"
            v-if="isEnableKetThuc() && !isViewAsUyQuyen"
          >
            <i class="fas fa-check-circle font-size__small"></i>
            &nbsp;{{ getKetThucLabel() }}
          </el-button>

          <el-button
            type="info"
            class="addDocs bg__silver color__white btn-none__border"
            @click="isOpenThuHoiVanThuDialog = true"
            v-if="
              !userVbIncomingProcessId &&
              incomingDoc &&
              incomingDoc.toDeptId == userDeptId &&
              incomingDoc.status == INCOMING_DOC_STATUS.DANG_XU_LY
            "
          >
            <i class="fas fa-arrow-circle-left font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>
          <el-button
            v-if="isEnableUpdate()"
            class="detailBtn detailBtnPrimary"
            @click="openUpdateDialog"
          >
            <i class="fas fa-pencil-alt font-size__small"></i>
            Cập nhật
          </el-button>

          <!-- (userVbIncomingProcess.status ===
                INCOMING_PROCESS_STATUS.DA_XU_LY ||
                userVbIncomingProcess.status ===
                  INCOMING_PROCESS_STATUS.KETTHUC) &&
              incomingDoc.status == INCOMING_DOC_STATUS.DANG_XU_LY && -->
          <el-button
            class="detailBtn detailBtnSecondary"
            @click="isOpenThuHoiDialog = true"
            v-if="
              userVbIncomingProcessId &&
              userVbIncomingProcess &&
              incomingDoc &&
              userVbIncomingProcess.receiverId == userId &&
              !isViewAsUyQuyen
            "
          >
            <i class="fas fa-undo font-size__small"></i>
            &nbsp;Thu hồi
          </el-button>
          <el-button
            class="detailBtn detailBtnPrimary"
            @click="isOpenTransferBoSungDialog = true"
            v-if="!userVbIncomingProcess && roleCode == 'vanthu'"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            &nbsp;Chuyển xử lý bổ sung
          </el-button>

          <el-button
            class="detailBtn detailBtnPrimary"
            @click="openGiaoViecDialog"
            v-if="isEnableGiaoViec && checkPermissionAssignTask"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Giao việc
          </el-button>

          <!-- <el-button
            class="detailBtn detailBtnPrimary"
            @click="exportTiepNhanVanBanReport"
            v-if="isEnableExportTiepNhanVanBanReport"
          >
            <i class="fas fa-fast-forward font-size__small"></i>
            Báo cáo tiếp nhận
          </el-button> -->
          <el-button
            class="detailBtn detailBtnAlert"
            @click="isOpenTuChoiDialog = true"
            v-if="isTuChoi()"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>
          <el-button
            class="detailBtn detailBtnAlert"
            @click="isOpenTuChoiVanThuDialog = true"
            v-if="isTuChoiVanThu()"
          >
            <i class="fas fa-ban font-size__small"></i>
            &nbsp;Từ chối
          </el-button>

          <el-button
            v-if="!isViewAsUyQuyen"
            class="detailBtn detailBtnSecondary"
            @click="openCCDialog()"
          >
            <i class="fas fa-share-all font-size__small"></i>
            &nbsp;CC
          </el-button>

          <el-button
            class="detailBtn btn__delete btn-none__border color__white bg__red"
            @click="delete_()"
            v-if="isEnableDelete"
          >
            <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa
          </el-button>

          <el-button
            v-if="isUpdateFile"
            class="dialogBtnPrimary"
            @click="updateFile()"
            :disabled="isProcessing"
          >
            <i :class="[!isProcessing ? 'fas fa-save' : 'el-icon-loading']"></i>
            &nbsp;Cập nhật file
          </el-button>
        </div>
      </div>

      <cxl-vbden-dialog
        :isOpen="isOpenTransferDialog"
        :quote="incomingDoc.quote"
        :incomingProcessId="userVbIncomingProcessId"
        v-if="isEnableTransferDialog"
        @closed="isEnableTransferDialog = false"
        @closeDialog="isOpenTransferDialog = false"
        @success="chuyenXuLiSuccess"
      />

      <cxl-vbden-bosung-vanthu-dialog
        :isOpen="isOpenTransferBoSungDialog"
        :docId="id"
        :quote="incomingDoc.quote"
        v-if="isEnableTransferBoSungDialog"
        @closed="isEnableTransferBoSungDialog = false"
        @closeDialog="isOpenTransferBoSungDialog = false"
        @cxlBoSungSuccess="cxlBoSungSuccess"
      />

      <DocOutKetThuc
        :title="getDocOutKetThucTitle()"
        :isOpen="isOpenKetThucDialog"
        :objects="[{ docId: id, processId: userVbIncomingProcessId }]"
        v-if="isEnableKetThucDialog"
        @closed="isEnableKetThucDialog = false"
        @closeDialog="isOpenKetThucDialog = false"
        @success="ketThucSuccess"
      />

      <ChoYKienDialog
        :isOpen="isOpenChoYKienDialog"
        :vbIncomingId="incomingDoc.id"
        :processId="userVbIncomingProcessId"
        :vbOutgoingDocId="incomingDoc.vbOutgoingDocId"
        v-if="isEnableChoYKienDialog"
        @closed="isEnableChoYKienDialog = false"
        @closeDialog="isOpenChoYKienDialog = false"
        @success="choYKienSuccess"
      />

      <thu-hoi-vb-den-dialog
        :isOpen="isOpenThuHoiDialog"
        :vbIncomingProcessId="userVbIncomingProcessId"
        v-if="isEnableThuHoiDialog"
        @dialogClosed="isEnableThuHoiDialog = false"
        @closeDialog="
          (isOpenThuHoiDialog = false), (isEnableThuHoiDialog = false)
        "
        @success="vbIncomingProcessThuHoiSuccess"
      />

      <thuHoiVanThuDialog
        :isOpen="isOpenThuHoiVanThuDialog"
        :vbIncomingDocId="id"
        v-if="isEnableThuHoiVanThuDialog"
        @dialogClosed="isEnableThuHoiVanThuDialog = false"
        @closeDialog="isOpenThuHoiVanThuDialog = false"
        @success="thuHoiVanThuSuccess"
      />

      <tu-choi-dialog
        :isOpen="isOpenTuChoiDialog"
        :vbIncomingDocId="userVbIncomingProcessId"
        v-if="isEnableTuChoiDialog"
        @dialogClosed="isEnableTuChoiDialog = false"
        @closeDialog="isOpenTuChoiDialog = false"
        @success="tuChoiSuccess"
      />

      <task-create-dialog
        :isOpen="isOpenCreateJobDialog"
        :taskType="TASK_TASK_TYPE.GIAOVIEC"
        :viewType="JOB_INDEX_PAGE.VIEW_TYPE.ASSIGNER"
        :docId="id"
        :docType="DOC_TYPE.VB_DEN"
        v-if="isEnableCreateJobDialog"
        @dialogClosed="isEnableCreateJobDialog = false"
        @closeDialog="isOpenCreateJobDialog = false"
        @success="createTaskSuccess"
      />

      <vb-den-update-dialog
        :id="id"
        :isOpen="isUpdateDialogOpen"
        v-if="isUpdateDialogEnable"
        @dialogClosed="isUpdateDialogEnable = false"
        @closeDialog="closeDialog"
        @success="updateDocSuccess"
      />

      <!-- CC văn bản -->
      <CCDocIn
        :isOpen="isOpenDocInCCDialog"
        :docId="id"
        :docTitle="incomingDoc.quote"
        :docCode="incomingDoc.docCode"
        :incomingProcessId="userVbIncomingProcessId"
        @closeDialog="isOpenDocInCCDialog = false"
        @closed="isEnableDocInCCDialog = false"
        v-if="isEnableDocInCCDialog"
        @success="ccSuccess"
      />
    </template>

    <template v-slot:side="{ hideSide }">
      <doc-in-histories-v2
        :vbIncomingDocId="activeDocId"
        :mainVbIncomingDocId="id"
        :sub-doc-id="id"
        @closeHistory="hideSide"
        v-if="!vbDocBccInfo"
        :isEnableComment="!isAutoBccDuThao"
      ></doc-in-histories-v2>
      <history-docout
        v-else
        :vbOutgoingDocId="vbDocBccInfo.vbOutgoingDocId"
        :isEnableComment="false"
        @closeHistory="hideSide"
      ></history-docout>
    </template>
  </detail-template-v2>
</template>

<script>
import HistoryDocin from "./History";
import incomingDocService from "../../services/incomingDocService";
import attachmentService from "../../services/attachmentService";
import constants from "../../constants";
import vbStepService from "../../services/vbStepService";
import vbIncomingProcessService from "../../services/vbIncomingProcessService.js";
import vbFlowInstanceService from "../../services/vbFlowInstanceService.js";
import DocOutKetThuc from "./components/DocOutKetThuc";
import ChoYKienDialog from "./components/ChoYKienDialog";
import dateFormatter from "../../filters/dateFormatter";
import categoryViewService from "../../services/categoryViewService";
import h from "../../services/h";
import utils from "../../services/utils";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import docInBookService from "../../services/docInBookService";
import { EventBus } from "../../event-bus.js";
import nextStepInfoViewService from "../../services/nextStepInfoViewService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import docRelationService from "../../services/docRelationService";
import vbDelegateInfoService from "../../services/vbDelegateInfoService";
import CxlVbdenDialog from "./components/cxl-vbden-dialog";
import CxlVbdenBosungVanthuDialog from "./components/cxl-vbden-bosung-vanthu-dialog";
import TaskCreateDialog from "../job/create-job/task-create-dialog";
import menuConfigService from "../../services/menuConfigService";
import VbdenLuongxuly from "./components/LuongXuLy";
import ThuHoiVbDenDialog from "./components/thuHoiDialog";
import VbDenUpdateDialog from "./components/vb-den-update-dialog";
import vbOpinionFormService from "../../services/vbOpinionFormService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import vbDocUserService from "../../services/vbDocUserService";
import vbDocBccInfoService from "../../services/vbDocBccInfoService";
import VbdiLuongxulyWrapper from "../doc-out/vbdi-luongxuly-wrapper";
import HistoryDocout from "../doc-out/History";
import TuChoiDialog from "./components/tuChoiDialog";
import VbProcessTypeTag from "./vb-process-type-tag";
import DetailTemplate from "../common/detail";
import DetailTemplateV2 from "../common/layout/detail-template-v2";
import DocPriorityTag from "../common/doc-priority-tag";
import DocProcessTypeTag from "./doc-process-type-tag";
import DocBccTag from "./doc-bcc-tag";
import DocInHistoriesV2 from "./doc-in-histories-v2";
import departmentService from "../../services/departmentService";
import DocRelationsDetail from "./doc-relations-detail";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import CCDocIn from "./components/CCDocIn.vue";
import vbNotificationService from '../../services/vbNotificationService';

export default {
  mixins: [uploadFileMixin, vbAttachmentTokenMixin],

  components: {
    DocInHistoriesV2,
    DocBccTag,
    DocProcessTypeTag,
    DocPriorityTag,
    DetailTemplateV2,
    DetailTemplate,
    TaskCreateDialog,
    VbProcessTypeTag,
    TuChoiDialog,
    HistoryDocout,
    HistoryDocin,
    VbdiLuongxulyWrapper,
    ThuHoiVbDenDialog,
    VbDenUpdateDialog,
    VbdenLuongxuly,
    ChoYKienDialog,
    CxlVbdenBosungVanthuDialog,
    CxlVbdenDialog,
    DocOutKetThuc,
    DocRelationsDetail,
    CCDocIn,
    thuHoiVanThuDialog: () => import("./components/thuHoiVanThuDialog"),
    // tuChoiVanThuDialog: () => import("./components/tuChoiVanThuDialog"),
    fileTypeImage: () => import("../common/FileTypeImage"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },

  filters: { dateFormatter, buildAttachmentURL },

  data() {
    return {
      DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT:
        constants.DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT,
      form: {
        attachmentFiles: [],
        attachmentId: null,
      },
      isUploadingDocFlag: null,
      DOCUMENT_FILE: constants.DOCUMENT_FILE,
      // Upload file
      departments: [],
      isPhieuYKien: false,
      isExistOpnionForm: false,
      docRelationTypes: [],
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      docRelations: [],

      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      settings: { maxScrollbarLength: 750 },
      tabHistory: true,
      nextSteps: null,
      incomingDoc: {},
      vbAttachment: {},
      docReceivers: null,
      userVbIncomingProcess: null,
      flowInstance: null,
      flowInstanceId: null,
      flowId: null,
      stepId: null,
      step: null,
      vbDocInBook: null,
      delegateInfo: null,

      isDocOutTuChoiDialogOpen: false,
      isTuChoiSuccess: false,
      isOpenThuHoiDialog: false,
      isEnableThuHoiDialog: false,
      isOpenThuHoiVanThuDialog: false,
      isEnableThuHoiVanThuDialog: false,
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,
      isOpenTransferBoSungDialog: false,
      isEnableTransferBoSungDialog: false,
      isOpenTuChoiDialog: false,
      isEnableTuChoiDialog: false,
      isOpenTuChoiVanThuDialog: false,
      isEnableTuChoiVanThuDialog: false,
      isOpenKetThucDialog: false,
      isEnableKetThucDialog: false,
      isOpenChoYKienDialog: false,
      isEnableChoYKienDialog: false,

      INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
      INCOMING_PROCESS_STATUS: constants.INCOMING_PROCESS_STATUS,
      STEP_POS_TYPE: constants.STEP_POS_TYPE,

      isEnableCXLDonVi: false,
      isEnableCXLCaNhan: false,

      isOpenDocInCCDialog: false,
      isEnableDocInCCDialog: false,

      isOpenCreateJobDialog: false,
      isEnableCreateJobDialog: false,
      isUpdateDialogOpen: false,
      isUpdateDialogEnable: false,

      TASK_TASK_TYPE: constants.TASK_TASK_TYPE,
      JOB_INDEX_PAGE: constants.JOB_INDEX_PAGE,
      giaoViecMenuConfig: null,
      DOC_TYPE: constants.DOC_TYPE,
      activeDocId: null,
      HDTV_DEPT_CODE: constants.HDTV_DEPT_CODE,
      forwardIncomingProcess: null,
      docTypes: [],
      steeringTypeLabel: null,
      isLawDocument: null,
      vbDocUser: null,
      vbDocBccInfo: null,
      isProcessing: false,
    };
  },

  computed: {
    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN,
        note: "",
      };
    },

    isUpdateFile() {
      return (
        this.isVanThu &&
        this.incomingDoc &&
        this.userDeptId === this.incomingDoc.toDeptId &&
        !this.incomingDoc.vbOutgoingDocId
      );
    },

    isAutoBcc() {
      return (
        this.vbDocUser &&
        this.vbDocUser.relationType ===
          constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
      );
    },

    isAutoBccDuThao() {
      //lưu ý, flag đánh dấu là chuyển xử lý bcc văn bản đi;
      return this.isAutoBcc && !!this.vbDocBccInfo;
    },

    signerName() {
      if (this.incomingDoc) {
        return this.incomingDoc.signerUserDeptRoleId
          ? `${this.incomingDoc.signerName} (${this.incomingDoc.signerPosName} ${this.incomingDoc.signerDeptName})`
          : this.incomingDoc.signerName;
      } else {
        return null;
      }
    },

    isBanHanhTrucLienThong() {
      return this.incomingDoc && this.incomingDoc.tltvbAgencyId;
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isVanThu() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
      );
    },
    isEnableDelete() {
      //văn thư được phép xóa văn bản ký ngoài
      return (
        this.isVanThu &&
        this.incomingDoc &&
        this.userDeptId === this.incomingDoc.toDeptId &&
        !this.incomingDoc.vbOutgoingDocId &&
        !this.incomingDoc.forwardIncomingDocId
      );
    },
    userDeptId() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.deptId
      );
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    roleCode() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.roleCode
      );
    },
    deptCode() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.deptCode
      );
    },
    userId() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.userId
      );
    },
    isEndNode() {
      return (
        !this.step ||
        this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
        this.step.posType == constants.STEP_POS_TYPE.BOTH
      );
    },
    parentRoute() {
      return this.$route.path.split("/")[3];
    },
    id() {
      return this.$route.params.id;
    },
    userVbIncomingProcessId() {
      return this.$route.query.vbDocProcessId;
    },
    isViewAsUyQuyen() {
      return (
        this.delegateInfo &&
        this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId
      );
    },
    isEnableGiaoViec() {
      return this.giaoViecMenuConfig !== null;
    },
    isEnableExportTiepNhanVanBanReport() {
      return this.roleCode === constants.ROLE.CODE.VAN_THU;
    },
    checkPermissionAssignTask() {
      return (
        (this.nextSteps && this.nextSteps.length) ||
        this.roleCode !== constants.ROLE.CODE.CHUYEN_VIEN
      );
    },
  },

  watch: {
    isUpdateDialogOpen(newValue) {
      newValue && (this.isUpdateDialogEnable = newValue);
    },
    isOpenDocInCCDialog(newValue) {
      newValue && (this.isEnableDocInCCDialog = newValue);
    },
    nextSteps(newValue) {
      this.isEnableCXLDonVi = h.find(
        this.nextSteps,
        (step) => step.stepType == constants.STEP.STEP_TYPE.DONVI
      );
      this.isEnableCXLCaNhan = h.find(
        this.nextSteps,
        (step) => step.stepType == constants.STEP.STEP_TYPE.CANHAN
      );
    },
    isOpenThuHoiDialog(newValue) {
      newValue && (this.isEnableThuHoiDialog = newValue);
    },
    isOpenTuChoiDialog(newValue) {
      newValue && (this.isEnableTuChoiDialog = newValue);
    },
    isOpenTuChoiVanThuDialog(newValue) {
      newValue && (this.isEnableTuChoiVanThuDialog = newValue);
    },
    isOpenThuHoiVanThuDialog(newValue) {
      newValue && (this.isEnableThuHoiVanThuDialog = newValue);
    },
    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },
    isOpenTransferBoSungDialog(newValue) {
      newValue && (this.isEnableTransferBoSungDialog = newValue);
    },
    isOpenKetThucDialog(newValue) {
      newValue && (this.isEnableKetThucDialog = newValue);
    },
    isOpenChoYKienDialog(newValue) {
      newValue && (this.isEnableChoYKienDialog = newValue);
    },
    id(newValue) {
      if (newValue) {
        this.vbDocInBook = null;
        this.activeDocId = newValue;
        this.loadDocInfo();
        this.getBookNumber();
        this.getBookNumber();
      }
    },
    isOpenCreateJobDialog(newValue) {
      newValue && (this.isEnableCreateJobDialog = newValue);
    },
  },

  created() {
    if (this.id) {
      this.activeDocId = this.id;
      this.loadDepartments();
      this.loadCategories();
      this.loadDocInfo();
      this.getBookNumber();
      this.initForGiaoViecButton();
    }
  },

  methods: {
    ccSuccess() {
      this.isOpenDocInCCDialog = false;
      this.backModel();
    },

    openCCDialog() {
      this.isOpenDocInCCDialog = true;
    },

    checkCurrentActive() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.status === "active" &&
        this.$store.getters.userDeptRole.deptStatus === "active"
      );
    },
    // Bắt đầu cập nhật
    updateFile() {
      attachmentService
        .updateFileService(this.id, 1, this.vbAttachment.fileServiceId)
        .then((res) => {
          this.$message({
            message: "Cập nhật thành công",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "Cập nhật thất bại",
            type: "error",
          });
        });
    },

    buildMessageUploadOnlyPdf() {
      return errorMessageFilter({ errorCode: "file.onlyAllowPdfType" });
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachment = vbAttachment;
      this.form.attachmentId = vbAttachment.id;
      this.form.numberOfPage = vbAttachment.pageNumber;
    },

    removeUploadAttachment() {
      this.vbAttachment = null;
      this.form.attachmentId = null;
      this.form.attachmentFiles = [];
    },
    // end Cập nhật file
    loadDepartments() {
      departmentService.findAll().then((response) => {
        this.departments = response.data;
      });
    },
    labelDepartmentPublic() {
      let department = this.departments.find(
        (x) => x.id === this.incomingDoc.publisherId
      );
      return !department
        ? this.incomingDoc.publisherName
        : `${department.deptName} ${
            department.parentName ? ` (${department.parentName})` : ""
          }`;
    },
    initSteeringTypeLabel() {
      switch (this.incomingDoc.steeringType) {
        case constants.STEERING_TYPE.KHONGPHAICHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao",
          });
          break;
        case constants.STEERING_TYPE.CHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.chidao",
          });
          break;
        case constants.STEERING_TYPE.BAOCAOCHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao",
          });
          break;
      }
    },

    loadVbOpinionForm() {
      return (
        this.isPhieuYKien
          ? vbOpinionFormService
              .findByDocIdAndUser(
                this.incomingDoc.vbOutgoingDocId,
                this.userDeptRoleId
              )
              .then((response) => response.data)
          : Promise.resolve(null)
      ).then((vbOpinionForm) => {
        this.isExistOpnionForm = !!vbOpinionForm;
        return vbOpinionForm;
      });
    },

    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.incomingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).then(() => {
        incomingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000,
            });
            this.backModel();
            EventBus.$emit(this.parentRoute, {});
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },

    isEnableUpdate() {
      return (
        this.incomingDoc &&
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.roleCode ==
          constants.ROLE.CODE.VAN_THU &&
        (this.$store.getters.user.id === this.incomingDoc.creatorId ||
          this.$store.getters.user.deptId === this.incomingDoc.toDeptId) &&
        this.incomingDoc.vbOutgoingDocId == null &&
        this.incomingDoc.forwardIncomingDocId == null &&
        this.incomingDoc.status == constants.INCOMING_DOC_STATUS.DANG_XU_LY
      );
    },

    openUpdateDialog() {
      this.isUpdateDialogOpen = true;
    },

    viewDetail(item) {
      if (!item.forwardIncomingDocId) {
        this.$router.push({
          name: "vbChoTiepNhanDetailEditable",
          params: { id: item.id },
        });
      }
    },

    closeDialog() {
      this.isUpdateDialogOpen = false;
    },

    updateDocSuccess() {
      this.isUpdateDialogOpen = false;
      this.loadDocInfo();
    },

    isTuChoiVanThu() {
      return (
        this.roleCode === constants.ROLE.CODE.VAN_THU &&
        this.incomingDoc &&
        this.incomingDoc.status == constants.INCOMING_DOC_STATUS.TU_CHOI
      );
    },

    isTuChoi() {
      return (
        // !(
        //   this.forwardIncomingProcess &&
        //   this.forwardIncomingProcess.parentId != null
        // ) && 
        //là văn bản được chuyển từ đơn vị khác đến
        this.userVbIncomingProcess &&
        this.userVbIncomingProcess.status ==
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY && //người được nhận phải chưa xử lý văn bản
        this.step &&
        (((this.step.posType == constants.STEP_POS_TYPE.BAT_DAU ||
          this.step.posType == constants.STEP_POS_TYPE.BOTH) &&
          this.roleCode === constants.ROLE.CODE.LANH_DAO) || //nếu là lãnh đạo nhận đầu tiên thì có quyền từ chối
          this.step.isAbleToReject === constants.TRUE) //nếu cấu hình luồng cho phép từ chối
      );
    },

    docFlowChange(event) {
      this.activeDocId = event.docId;
    },

    exportTiepNhanVanBanReport() {
      utils.exportReport(constants.REPORT.TIEPNHANVANBAN.REPORT_URL, {
        userDeptRoleId: this.userDeptRoleId,
        docId: this.id,
        docType: constants.DOC_TYPE.VB_DEN,
      });
    },

    initForGiaoViecButton() {
      return menuConfigService
        .findAll({
          userDeptRoleId: this.userDeptRoleId,
          menuCode: constants.MENU_LIST.CONGVIEC_GIAO,
          status: constants.MENU_CONFIG.STATUS.ACTIVE,
        })
        .then((response) => {
          let menuConfigs = response.data;
          return (this.giaoViecMenuConfig =
            menuConfigs && menuConfigs.length ? menuConfigs[0] : null);
        });
    },

    createTaskSuccess() {
      this.isOpenCreateJobDialog = false;
    },

    openGiaoViecDialog() {
      this.isOpenCreateJobDialog = true;
    },

    cxlBoSungSuccess() {
      this.isOpenTransferBoSungDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    getRelationTypeLabel(relationType) {
      var docRelationType = h.find(
        this.docRelationTypes,
        (docRelationType) => docRelationType.id == relationType
      );

      return docRelationType ? docRelationType.categoryName : null;
    },

    loadNextSteps() {
      nextStepInfoViewService
        .nextSteps(this.flowId, this.stepId)
        .then((response) => (this.nextSteps = response.data));
    },

    getBookNumber() {
      docInBookService.findByDocId(this.$route.params.id).then((response) => {
        this.vbDocInBook = response.data;
      });
    },

    ketThucSuccess() {
      this.$message({
        message: "Kết thúc văn bản thành công",
        type: "success",
      });
      this.isOpenKetThucDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    choYKienSuccess() {
      this.$message({
        message: "Cho ý kiến thành công",
        type: "success",
      });
      this.isOpenChoYKienDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    getDocOutKetThucTitle() {
      // return this.userVbIncomingProcess && this.userVbIncomingProcess.processType == constants.PROCESS_TYPE.NHANDEBIET ? "Đã nhận văn bản" : "Kết thúc văn bản";
      return "Kết thúc văn bản";
    },

    getKetThucLabel() {
      // return this.userVbIncomingProcess && this.userVbIncomingProcess.processType == constants.PROCESS_TYPE.NHANDEBIET ? "Đã nhận" : "Kết thúc";
      return "Kết thúc";
    },

    vbIncomingProcessThuHoiSuccess(event) {
      this.isOpenThuHoiDialog = false;
      this.incomingDoc = event.vbIncomingProcess;
      if (event.vbIncomingProcess.status == 0) {
        EventBus.$emit(this.parentRoute, {});
      }
      this.backModel();
    },

    thuHoiVanThuSuccess(event) {
      this.incomingDoc = event.vbIncomingDoc;
      this.isOpenThuHoiVanThuDialog = false;
      if (event.vbIncomingDoc.status == 0) {
        EventBus.$emit(this.parentRoute, {});
      }
      this.backModel();
    },

    tuChoiSuccess(event) {
      this.isOpenTuChoiDialog = false;
      this.incomingDoc = event.vbIncomingDoc;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    tuChoiVanThuSuccess(event) {
      this.isOpenTuChoiDialog = false;
      this.incomingDoc = event.vbIncomingDoc;
      EventBus.$emit(this.parentRoute, {});
    },

    openDocInKetThucDialog() {
      this.isDocInKetThucDialogOpen = true;
    },

    isEnableNhanDeBiet() {
      return (
        this.isChoXuLy() &&
        this.userVbIncomingProcess.processType ==
          constants.PROCESS_TYPE.NHANDEBIET
      );
    },

    openTabHistory() {
      this.tabHistory = true;
    },

    closeTabHistory() {
      this.tabHistory = false;
    },

    markAsRead() {
      return (
        this.userVbIncomingProcessId
          ? vbIncomingProcessService.markAsRead(this.userVbIncomingProcessId)
          : Promise.resolve()
      ).then(() => null);
    },

    loadCategories() {
      h.each(
        [
          constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE,
        ],
        (item) => {
          categoryViewService
            .findAll({ groupCode: item }, { page: 0, size: 1000 })
            .then((response) => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                  return (this.docRelationTypes = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));
                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data.filter(
                    (item) => item.status !== "deactive"
                  ));
              }
            });
        }
      );
    },

    tuChoi() {
      this.isDocOutTuChoiDialogOpen = true;
    },

    openDocOutKetThucDialog() {
      this.isDocOutKetThucDialogOpen = true;
    },

    docOutTuChoiDialogClosed() {
      if (this.isTuChoiSuccess) {
        this.message(
          "Thông báo",
          "Từ chối văn bản thành công.",
          "success",
          3000
        );
        this.loadDocInfo();
      }
    },

    isEnableChuyenXuLiCaNhan() {
      return (
        this.userVbIncomingProcess &&
        [
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY,
          constants.INCOMING_PROCESS_STATUS.DA_XU_LY,
          constants.INCOMING_PROCESS_STATUS.KETTHUC,
        ].indexOf(this.userVbIncomingProcess.status) != -1 &&
        !this.isEndNode &&
        this.isEnableCXLCaNhan
      );
    },
    isEnableChuyenXuLiDonVi() {
      return (
        this.isEnableCXLDonVi &&
        this.userVbIncomingProcess &&
        this.userVbIncomingProcess.status !=
          this.INCOMING_PROCESS_STATUS.TU_CHOI
      );
    },

    isChoXuLy() {
      return (
        this.userVbIncomingProcess &&
        this.userVbIncomingProcess.status ==
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY
      );
    },

    chuyenXuLiSuccess(event) {
      this.loaduserVbIncomingProcess();
      this.isOpenTransferDialog = false;
      EventBus.$emit(this.parentRoute, {});
      this.backModel();
    },

    isEnableKetThuc() {
      return (
        this.incomingDoc &&
        (this.incomingDoc.status == constants.INCOMING_DOC_STATUS.DANG_XU_LY ||
          this.incomingDoc.status == constants.INCOMING_DOC_STATUS.TAO_MOI) &&
        (!this.flowInstance ||
          (this.flowInstance &&
            this.flowInstance.status ==
              constants.FLOW_INSTANCE_STATUS.DANG_XU_LY)) &&
        this.userVbIncomingProcess &&
        ([
          constants.INCOMING_PROCESS_STATUS.CHO_XU_LY,
          constants.INCOMING_PROCESS_STATUS.DA_XU_LY,
        ].indexOf(this.userVbIncomingProcess.status) != -1 ||
          !this.userVbIncomingProcess.status) &&
        this.userVbIncomingProcess.receiverId == this.userId
      );
    },

    loaduserVbIncomingProcess() {
      if (this.userVbIncomingProcessId) {
        vbIncomingProcessService
          .findById(this.userVbIncomingProcessId)
          .then((response) => {
            this.userVbIncomingProcess = response.data;
            this.flowInstanceId = this.userVbIncomingProcess.flowInstanceId;
            this.stepId = this.userVbIncomingProcess.stepId;
            vbStepService
              .findById(this.stepId)
              .then((response) => (this.step = response.data));

            if (this.userVbIncomingProcess.delegateInfoId) {
              vbDelegateInfoService
                .findById(this.userVbIncomingProcess.delegateInfoId)
                .then((response) => (this.delegateInfo = response.data));
            } else {
              this.delegateInfo = null;
            }
            vbFlowInstanceService
              .findById(this.flowInstanceId)
              .then((response) => {
                this.flowInstance = response.data;
                this.flowId = this.flowInstance.flowId;
                this.loadNextSteps();
              });
          });
      }
    },

    modelBack() {
      this.$router.back();
    },

    activeFocusCommentScope() {
      this.$store.commit("unFocusCommentScope");
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1 || id === "16";
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    backModel() {
      this.$router.push({
        name: this.parentRoute,
        params: this.$route.params,
        query: this.$route.query,
      });
    },

    loadForwardProcess() {
      if (!this.incomingDoc || !this.incomingDoc.forwardIncomingProcessId)
        return Promise.resolve(null);
      return vbIncomingProcessService
        .findById(this.incomingDoc.forwardIncomingProcessId)
        .then((res) => (this.forwardIncomingProcess = res.data));
    },

    isToTrinhOrGiaiTrinh(docTypeCode) {
      return (
        docTypeCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTV ||
        docTypeCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTV
      );
    },

    loadDocInfo() {
      incomingDocService.findById(this.id).then((response) => {
        // Danh dau da doc thong bao
        let notis = this.$store.getters.notifies || [];
        notis.filter((x) => {
          if (utils.getDataNoti(x).id === this.id && x.status !== "seen") {
            vbNotificationService.maskAsSeen(x);
          }
        });
        this.incomingDoc = response.data;
        this.isLawDocument = this.incomingDoc.isLawDocument === constants.TRUE;
        this.initSteeringTypeLabel();
        this.isPhieuYKien = this.isToTrinhOrGiaiTrinh(
          this.incomingDoc.docTypeCode
        );
        this.markAsRead();
        this.loadForwardProcess();
        this.loadVbOpinionForm();
      });

      this.loadVbAttachment();
      this.loadVbDocRelation();
      this.loaduserVbIncomingProcess();
      this.loadVbDocUserForAutoBcc().then(() =>
        Promise.all([this.markAsDaXLForBcc(), this.loadVbDocBccInfo()])
      );
    },

    /**
     * load van ban lien quan;
     * @returns {Promise<T>}
     */
    loadVbDocRelation() {
      return docRelationService
        .findAll({
          objectId: this.id,
          objectType: constants.DOC_RELATION_OBJECT_TYPE.VB_DEN,
        })
        .then((response) => (this.docRelations = response.data));
    },

    loadVbAttachment() {
      return attachmentService
        .findAll({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DEN,
        })
        .then((response) => {
          if (response.data && response.data.length) {
            this.vbAttachment = response.data[0];
          }
        });
    },

    backListPage() {
      this.backModel();
    },

    openCxlDialog() {
      this.isOpenTransferDialog = true;
    },

    loadVbDocUserForAutoBcc() {
      return (
        !this.userVbIncomingProcessId
          ? vbDocUserService
              .findByDocIdAndRelationType(
                this.id,
                constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
              )
              .then((response) => response.data)
          : vbDocUserService
              .findByVbIncomingProcessId(this.userVbIncomingProcessId)
              .then((response) => response.data)
      ).then((vbDocUser) => (this.vbDocUser = vbDocUser));
    },

    /**
     * đối với các văn bản được chuyển dạng bcc, thì khi xem văn bản là đã tính đã xử lý;
     */
    markAsDaXLForBcc() {
      return (
        this.isAutoBcc && !this.userVbIncomingProcessId
          ? vbDocUserService.markAsDaXLForBcc(this.vbDocUser.id)
          : Promise.resolve()
      ).then(() => null);
    },

    loadVbDocBccInfo() {
      return (
        this.isAutoBcc
          ? vbDocBccInfoService
              .findAllByVbIncomingDocId(this.id)
              .then((response) => response.data)
          : Promise.resolve(null)
      ).then((vbDocBccInfo) => (this.vbDocBccInfo = vbDocBccInfo));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/doc-in/detail-v2.vue